import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getDiscountSchemes = createAsyncThunk(
  "DiscountScheme/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => params.append(key, item));
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.DISCOUNT_SCHEME.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDiscountSchemeById = createAsyncThunk(
  "DiscountScheme/getById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.DISCOUNT_SCHEME.SLUG}/${id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const createDiscountScheme = createAsyncThunk(
  "DiscountScheme/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.DISCOUNT_SCHEME.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editDiscountScheme = createAsyncThunk(
  "DiscountScheme/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.DISCOUNT_SCHEME.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteDiscountScheme = createAsyncThunk(
  "DiscountScheme/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.DISCOUNT_SCHEME.SLUG}/${id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getActiveItems = createAsyncThunk(
  "discountScheme/getActiveItems",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (payload.searchText) params.append("SearchText", payload.searchText);
      params.append("PageNumber", payload.pageNumber || 1);
      params.append("PageSize", payload.pageSize || 200);
      const queryString = params.toString();
      const { data } = await axios.get(
        `${API_URL.ITEM.ACTIVE_ITEMS_LOOKUP}${queryString ? `?${queryString}` : ""}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateDiscountSchemeStatus = createAsyncThunk(
  "DiscountScheme/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.DISCOUNT_SCHEME.SLUG}/UpdateStatus/${id}/${status}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const discountSchemeSlice = createSlice({
  name: "discountScheme",
  initialState: {
    list: [],
    current_values: null,
    active_payload: null,
    active_items: [],
    items_loading: false,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDiscountSchemes.fulfilled, (state, action) => {
      state.list = action.payload.data.list;
    });
    builder.addCase(getDiscountSchemeById.fulfilled, (state, action) => {
      state.current_values = action.payload;
    });
    builder.addCase(getActiveItems.pending, (state) => {
      state.items_loading = true;
    });
    builder.addCase(getActiveItems.fulfilled, (state, action) => {
      state.active_items = action.payload?.list || [];
      state.items_loading = false;
    });
    builder.addCase(getActiveItems.rejected, (state) => {
      state.items_loading = false;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  discountSchemeSlice.actions;
export default discountSchemeSlice.reducer;
